// JS file for ProductItem

import u from '@main';

// u.$ui.bootstrap.tooltip();

const form = '#product-form';

u.formValidation()
  .then(() => u.$ui.disableOnSubmit(form));
u.form(form).initComponent();
u.$ui.keepAlive(location.href);

const image = $('.j-image');
let preview = $('.j-preview');

image.on('mouseenter', (e, i) => {
  const $this = $(e.currentTarget);

  preview.attr('src', $this.attr('src'));
});
